import * as yup from "yup";

export const AddTrainingTypeSchema = yup.object().shape({
  AddTrainingType: yup
    .string().trim()
    .required("Please enter training name!")
    .matches(
      /^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/,
      "Only alphanumeric and special characters like ':#@?[]_`| are allowed"
    ),
});
export const EditTrainingTypeSchema = yup.object().shape({
  EditTrainingType: yup
    .string()
    .required("Please enter training name!")
    .matches(
      /^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/,
      "Only alphanumeric and special characters like ':#@?[]_`| are allowed"
    ),
});
